import React from "react";
import "./arrowRight.css";

const ArrowRight = (props) => {
  const { color } = props;
  return (
    <span className={`icon-arrow_classic_right ${color}`} aria-hidden="true" />
  );
};

export default ArrowRight;
